export default class AudioFileModel {
	public value: string;
	public fileName: string;
	public audioDuration: number;
	public language?: string;

	constructor() {
		this.value = "";
		this.audioDuration = 0;
		this.fileName = "";
	}
}
